<template>
  <asc-role-grid-wrapper
    :title="title"
    :values="values"
    :on-open="onOpen"
    :on-add-role="onAddRole"
  ></asc-role-grid-wrapper>
</template>

<script>
import AscRoleGridWrapper from '@/components/organisms/AscRoleGridWrapper'
export default {
  name: 'AscRoleGridTemplate',
  components: {
    AscRoleGridWrapper,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Admin - Role Management',
    },
    onAddRole: {
      type: Function,
      default: () => {},
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
